<template>
  <el-form size="mini" v-model="fromCup">
    <el-form-item label="奖杯">
      <el-input placeholder="起始分" size="mini" style="width: 68px;" v-model="fromCup.fromPoint"></el-input>
      -
      <el-input placeholder="结束分" size="mini" style="width:68px;" v-model="fromCup.toPoint"></el-input>
      <span style="padding-left: 10px;">
          <label style="padding-right: 10px;">报价文本包含预计时间</label>
             <el-switch
               v-model="fromCup.showTime"
             >
      </el-switch>
        </span>
    </el-form-item>
  </el-form>
</template>

<script>
  export default {
    name: 'Cup',
    data () {
      return {
        gameId: 51,
        fromCup: {
          fromPoint: '',
          toPoint: '',
          showTime: true,
          inscriptionId: 0,
        }
      }
    },
    mounted () {
    },
    methods: {

    }
  }
</script>

<style scoped>

</style>
